import { useCallback, useMemo } from "react";
import { mutate } from "swr";

import { AssociateAdmin } from "@organization/models/AssociateAdmin";
import { AdminPortalUserRole } from "@organization/models/OrganizationUserDetails";

import { associateUserEndpoints } from "@api/Endpoints";
import { postData } from "@hooks/usePostData";

export function useAssociateAdmin() {
  const associate = useCallback(
    async (associateUser: AssociateAdmin, organizationId: string) => {
      const url = associateUserEndpoints.associate(organizationId);
      const result = await postData<
        AssociateAdmin & { organizationRole: string },
        boolean
      >(url, {
        ...associateUser,
        organizationRole: AdminPortalUserRole.OrganizationAdmin
      });

      const getUrl = associateUserEndpoints.get(organizationId);
      await mutate(getUrl);

      return result;
    },
    []
  );

  return useMemo(() => ({ associate }), [associate]);
}
